import { jsxs as l, Fragment as c, jsx as o } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import "./common.mjs";
import p from "./live-editing.mjs";
import m from "./server-component.mjs";
const S = a(
  ({ story: r, bridgeOptions: e, ...t }, n) => {
    if (!r)
      return console.error(
        "Please provide a 'story' property to the StoryblokServerComponent"
      ), null;
    if (globalThis.storyCache.has(r.uuid) && (r = globalThis.storyCache.get(r.uuid)), typeof r.content == "string")
      try {
        r.content = JSON.parse(r.content);
      } catch (i) {
        console.error(
          "An error occurred while trying to parse the story content",
          i
        ), r.content = {};
      }
    return /* @__PURE__ */ l(c, { children: [
      /* @__PURE__ */ o(m, { ref: n, blok: r.content, ...t }),
      /* @__PURE__ */ o(p, { story: r, bridgeOptions: e })
    ] });
  }
);
export {
  S as default
};
